import Vue from 'vue'
import App from './App.vue'
import router from './router'
import faviconUrl from './assets/favicon.ico'

const favicon = document.createElement('link')
favicon.rel = 'icon'
favicon.href = faviconUrl
document.head.appendChild(favicon)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
